import { useContext } from "react";
import { SortAndFilterContent } from "../../SortAndFilterContent";
import { selectedSvg } from "../../svg/svgList";
import { isMobileDevice } from "src/components/WidgetMaker/WidgetDnD/isMobileDevice";
import { getFilterOptionStyle } from "../../utils";
import { buttonStyle } from "src/utils/globalStyleHelper";
import { useWidgetDndContextData } from "src/context/WidgetDndContext";

function Layout2(props) {
  const { handleCheckboxClick, pageStyle } = useContext(SortAndFilterContent);
  const { filterData, filterName, isCustomType = false } = props
  const isMobile = isMobileDevice();
  const {
    widgetContextState: { globalStyle },
  } = useWidgetDndContextData();

  const globalRadius = buttonStyle(globalStyle, 6)

  function handleClick() {
    const eventData = {
      target: {
        checked: !filterData?.is_selected,
      }
    }
    handleCheckboxClick?.(eventData, filterName, filterData?.name)
  }

  return (
    <div style={{ ...globalRadius }} onClick={handleClick} className={`tw-border tw-cursor-pointer tw-border-solid ${isCustomType ? 'tw-flex tw-items-center tw-gap-[6px]' : ''} ${filterData?.is_selected ? 'tw-border-[#2B74D8]' : 'tw-border-[#111C3633]'} tw-p-[5px]`}>
      {(isCustomType && filterData?.is_selected) && <div className="tw-pt-[2px]">{selectedSvg()}</div>}
      <div style={{ ...getFilterOptionStyle(pageStyle, isMobile) }} className={`tw-text-[14px] tw-font-normal tw-text-[#111C36B2] ${filterData?.is_selected ? 'tw-font-semibold tw-text-newBlack' : ''}`}>{filterData?.name}</div>
    </div>
  )

}

export default Layout2;